<template>
    <div class="box">
        <div class="table__header p-3">
            <h4>Tours</h4>
        </div>
        <div class="row p-3">
            <div class="col-md-4">
                <div class="form-group">
                <label for="tours" class="form-label"> Tours </label>
                    <v-select
                        :options="[
                            {
                                id: 0,
                                name:'All'
                            },
                            ...tours
                        ]"
                        label="name"
                        class="m-0"
                        id="tour"
                        index="id"
                        multiple
                        v-model="seletcedTours"
                    />
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                <label for="" class="form-label">Departure Date Range </label>
                    <date-range-picker v-model="departureDueDateRange" format="mm/dd/yyyy" opens="center" @update="checkOpenPicker" class="form-control">
                        <!-- header slot-->
                        <div slot="header" slot-scope="header" class="slot-date-range-picker">
                            <h3 class="m-0">Calendar header</h3> <span v-if="header.in_selection"> - in selection</span>
                        </div>
                        <!-- input slot (new slot syntax) -->
                        <template #input="picker">
                            {{ picker.startDate | date }} - {{ picker.endDate | date }}
                        </template>
                        <!-- date slot-->
                        <template #date="data">
                            <span class="small">{{ data.date | dateCell }}</span>
                        </template>
                        <!-- ranges (new slot syntax) -->
                        <template #ranges="ranges">
                            <div class="ranges">
                                <ul>
                                <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                                    <b>{{ name }}</b> <small class="text-muted">{{ range[0].toDateString() }} - {{ range[1].toDateString() }}</small>
                                </li>
                                </ul>
                            </div>
                        </template>
                        <!-- footer slot -->
                        <div slot="footer" slot-scope="data" class="slot-date-range-picker">
                            <div class="p-2">
                                <b class="text-black">Calendar footer</b> {{ data.rangeText }}
                            </div>
                            <div style="margin-left: auto">
                                <a @click="data.clickApply" v-if="!data.in_selection" class="btn btn-primary btn-sm">Choose current</a>
                            </div>
                        </div>
                    </date-range-picker>
                </div>
            </div>
            <!-- <div class="col-md-2"></div> -->
            <div class="col-md-1" style="margin-top: 40px;">
                <button class="button button--large ms-2" @click="doSearch"><span>Search</span></button>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <vdtnet-table
                    ref="table"
                    :fields="fields"
                    :opts="options"
                    :key="tourTableKey"
                />
            </div>
        </div>
    </div>
</template>

<script>
import 'datatables.net'
import 'datatables.net-select'
import VdtnetTable from 'vue-datatables-net'

import moment from 'moment';

export default {
    name: 'TourSummary',
    components: {
        VdtnetTable,
    },
    props: {
      tours: {
        type: Array,
        default: () => []
      },  
    },
    data() {
        return {
            tourTableKey: 0,
            selected_tours:[],
            departureDueDateRange: {
                startDate : '',
                endDate : '',
            },
            options: {
                ajax: {
                    url: this.$api + 'summary/tour-summary',
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                },
                order:[[2, 'desc']],
                responsive: false,
                processing: true,
                searching: true,
                searchDelay: 1500,
                destroy: true,
                ordering: true,
                lengthChange: true,
                serverSide: true,
                dom: 'rtlip',
                autoWidth: false,
                lengthMenu: [ [5, 25, 50, 100, 500], [5, 25, 50, 100, 500] ],
                pageLength: 25,
                select: {
                    style: 'multi'
                }
            },
            fields: {
                tour_name: {
                    searchable: false,
                    label: 'Tour Name',
                    render: (data, type, row, meta) => {
                        return data
                    }
                },
                departure_date: {
                    searchable: false,
                    label: 'Departure Date',
                    render: (data, type, row, meta) => {
                        return `${moment(String(data)).format('DD/MM/YYYY')}`
                    }
                },
                total_guests: {
                    searchable: false,
                    label: 'Number of Guests',
                    render: (data, type, row, meta) => {
                        return data ? data : 0
                    }
                },
                confirmed_pax_count: {
                    searchable: false,
                    label: 'Confirmed Guests',
                    render: (data, type, row, meta) => {
                        return data ? `<b>${data}</b>` : 0
                    }
                }
            },
        }
    },
    computed: {
        seletcedTours : {
            get: function() {
                return this.selected_tours;
            },
            set: function (newValue) {
                if (newValue == 0) {
                    const ids = this.tours.map(obj => obj.id);
                    this.selected_tours = ids
                } else {
                    this.selected_tours = newValue
                }
            }
        },
    },
    filters: {
        dateCell (value) {
            let dt = new Date(value)
            return dt.getDate()
        },
        date (val) {
            return val ? val.toDateString() : ''
        }
    },
    methods: {
        checkOpenPicker() {
            this.departureDueDateRange.startDate = moment(this.departureDueDateRange.startDate).format('YYYY-MM-DD')
            this.departureDueDateRange.endDate = moment(this.departureDueDateRange.endDate).format('YYYY-MM-DD')
        },
        doSearch() {

            const ajaxUrl = this.$api + 'summary/tour-summary'
            const queryString = new URLSearchParams();

            if (this.selected_tours.length > 0) {
                queryString.set('search_by_tour_ids', this.selected_tours.join(','));
            }

            if (this.departureDueDateRange.startDate && this.departureDueDateRange.endDate) {
                queryString.set('departure_start_range_start', this.departureDueDateRange.startDate);
                queryString.set('departure_start_range_end', this.departureDueDateRange.endDate);
            }

            const urlWithParams = `${ajaxUrl}?${queryString.toString()}`;

            // Update the datatable's AJAX URL with the Start Date & End Date query parameters
            this.options.ajax.url = urlWithParams;

            // Increment the tableKey to force re-render and fetch new data
            this.tourTableKey++;
            
        }
    }        
}
</script>

<style scoped>
.slot-date-range-picker {
  background-color: #aaa;
  padding: 0.5rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.slot-date-range-picker h3 {
  font-size: 1.0625rem;
}

.text-black {
  color: #000;
}
</style>